import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-georgia-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./georgia-state-form.component.html",
  styleUrl: "./georgia-state-form.component.scss",
})
export class GeorgiaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
